import { render, staticRenderFns } from "./u-mobile-header-foot-basic.vue?vue&type=template&id=6e7c97e0&scoped=true"
import script from "./u-mobile-header-foot-basic.vue?vue&type=script&lang=js"
export * from "./u-mobile-header-foot-basic.vue?vue&type=script&lang=js"
import style0 from "./u-mobile-header-foot-basic.vue?vue&type=style&index=0&id=6e7c97e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c97e0",
  null
  
)

export default component.exports